// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"a2918ef6","787":"fec03637","937":"1ec4108c","948":"17c04eb2"}[chunkId] + ".chunk.js";
};